<template>
  <b-container class="blog-post">
<b-row>
    <b-col md="12">
      <br>
      
        <p class="blog-date">02/14/18</p>
        <h1>NEW WAYS TO HAVE FUN THIS FAMILY DAY IN PICKERING</h1><br>
        <h1 style="font-weight: 600;font-style: italic;font-size: 25px;">Check out these great Family Day events in the
          New Seaton neighborhood</h1>
          <div class="blog-content">
        <p>Even if your family is never able to agree on what movie to watch together or where
          to order take-out from, there’s no doubt everyone will have a blast this Family Day exploring these exciting
          events just minutes from New Seaton. With so many fun things to do in the area, you can plan a different
          outing for every day of the long weekend. You might even discover a new favourite spot to spend quality time
          together. Whether you’re a bunch of foodies, athletes, theatre-lovers or bargain hunters, there’s something
          going on in the New Seaton area this weekend that you’re all sure to love. </p>
      
      <br>

          <b-img fluid src="/img/blogs/new-ways-to-have-fun-this-family-day-in-pickering.png" alt="Seasonal activities"  class="mb-0" />
          <p class="subtitle">Family Day Event</p>
          <p>This year on Family Day, the Pickering Recreation Complex, located at 1867 Valley
            Farm Road, will be holding an exciting celebration for the whole family. This interactive event has a focus
            on having fun and trying new things together, with activities including dance lessons, ice skating, mini
            putt, fitness classes, ping-pong, and craft lessons. The complex has so many activities and lessons planned
            there is sure to be something for everyone in the family to enjoy. You’ll love trying new things together,
            like archery or Zumba, learning a new skill or developing a new hobby, all the while making memories you’ll
            all cherish for years to come.</p>
          <a href="https://calendar.pickering.ca/default/Detail/2018-02-19-1000-Family-Day-Event" target="_blank" class="blog-readmore">Learn
            more about the Family Day Event here.</a>

      <br><br><br>

          <p class="subtitle">Pickering Waterfront Trail</p>
          <p>Featuring a path that runs along the shores of Lake Ontario and the St. Lawrence
            River, the Pickering Waterfront Trail is a perfect destination for a relaxing walk or leisurely bike ride
            that all ages can enjoy. In addition to being a great spot to celebrate nature and do some bird watching,
            the trail also features a playground, as well as a number of picnic tables and benches along the way. Don’t
            forget to bring a camera! What could be more picture-perfect than your family strolling over rolling hills
            and past breathtaking waterfront views?</p>
          <a href="https://www.waterfronttrail.org/pickering" target="_blank" class="blog-readmore">Learn more about
            the Waterfront Trail!</a>

      <br><br><br>


          <b-img fluid src="/img/blogs/new-ways-to-have-fun-this-family-day-in-pickering-2.png" alt="person standing in a snow-covered inlet"  class="mb-15" />
          <p class="subtitle">Herongate Barn Theatre</p>
          <p>Treat your favourite people this Family Day weekend to a re-vamped version of the
            classic dinner and a movie date by taking them to a dinner theater production. Located at 2885 Altona Road,
            the Herongate Barn Theatre is a re-purposed dairy barn that combines fine dining with rustic original
            architecture. Where else in the world can you and your family enjoy a mouth-watering gourmet buffet and
            professional live music while sitting in a manger or bull pen? After your meal, you’ll be ushered to the
            main theatre area where you and your family will be treated to a world-class live performance. Currently,
            the theatre is performing “When the Cat’s Away,” the story of two cats that get up to mischief when they’re
            left alone at home while their owners go on vacation. Your family will love this unique experience and
            won’t be able to agree on the best part of the evening: the great food or the hilarious show!</p>
          <a href="http://www.herongate.com/" target="_blank" class="blog-readmore">Learn more about Herongate Barn
            Theatre.</a>
  
      <br> <br> <br>

          <p class="subtitle">Pickering Markets</p>
          <p>A great way to spend a lazy weekend afternoon with the family is getting lost at
            the Pickering Markets, located at 1400 Squires Beach Road. At Pickering Markets, not only will you be able
            to stroll through a one-of-a-kind marketplace made up of a diverse collection of vendors, but you’ll also
            be helping support local Durham businesses. From comics and board games, to jewelry, candles, specialty
            teas, and sports memorabilia, there is truly a vendor for everyone in the family. The most popular feature
            of the Pickering Markets is its selection of antiques, which have antique hunters and day-trippers alike
            flocking in from across the GTA in search of a new treasure. There are also many mouth-watering restaurants
            to enjoy, as well as numerous places to grab a quick bite to eat or a coffee. Even if you don’t buy
            anything, you’ll love exploring the stalls and antiques with your family, with something exciting to be
            seen and a new deal to discover at every turn. </p>
          <a href="http://www.pickeringmarkets.com/" target="_blank" class="blog-readmore">Learn more about Pickering
            Markets.</a>
 <br> <br> <br>
          </div>
    </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    transition: {
      mode: 'out-in',
      css: false,
      appear: true,

      enter(el, done) {
        this.$root.layout.methods.triggerBlogEnterAnimation(done)
      },
      leave(el, done) {
        this.$root.layout.methods.triggerBlogLeaveAnimation(done)
      },
    },
  }

</script>

<style scoped>

</style>